import React from "react";
import Toasts from "@frameworks/shared-library/components/Toast/Toast";
function ToastModal(_a) {
    var visible = _a.visible, setVisible = _a.setVisible, message = _a.message, isError = _a.isError;
    return (React.createElement(React.Fragment, null, visible && (React.createElement("div", { className: "primary-place-order-toast-container" },
        React.createElement(Toasts, { show: visible, setShow: function (val) {
                setVisible(val);
            }, position: "bottom-center", message: message, parentClass: isError ? "Danger" : "Success", delay: 3000 })))));
}
export default ToastModal;
